<div class="dashboard-content notification-page-content">

  <div class="notification-header">
    <ul class="custom-nav-tabs" role="tablist">

      <li class="nav-item" style="position: relative;">
        <a class="nav-link" [class.active]="activeTab === 'all'" (click)="setActiveTab('all')" role="tab"
          style="cursor: pointer;">
          {{ 'notifications.all-updates' | translate }}
        </a>
      </li>

      <li class="nav-item" style="position: relative;">
        <a class="nav-link" [class.active]="activeTab === 'read'" (click)="setActiveTab('read')" role="tab"
          style="cursor: pointer;">
          {{ 'notifications.read-status' | translate }}
        </a>
      </li>

      <li class="nav-item" style="position: relative;">
        <a class="nav-link" [class.active]="activeTab === 'unread'" (click)="setActiveTab('unread')" role="tab"
          style="cursor: pointer;">
          {{ 'notifications.unread' | translate }}
        </a>
      </li>

    </ul>

    <button class="btn btn-primary" (click)="markAllAsRead()">
      {{ 'notifications.mark-all-read' | translate }}
    </button>
  </div>

  <div class="all-notifactios">

    <div class="notifactio-card" *ngFor="let item of pagedNotifications">

      <!-- Profile -->
      <div class="profile">

        <img *ngIf="item.attachments?.length > 0 && item.attachments[0]?.url" src="assets/images/luqta_favicon1.png"
          [alt]="item.attachments[0]?.name || 'Notification Image'" />

        <svg *ngIf="!item.attachments?.length || !item.attachments[0]?.url" xmlns="http://www.w3.org/2000/svg"
          width="57" height="58" viewBox="0 0 57 58" fill="none">

          <rect y="0.671875" width="56.8278" height="56.8278" rx="28.4139" fill="#F1E7D1" fill-opacity="0.4" />

          <ellipse cx="27.8667" cy="34.9823" rx="7.50556" ry="3.75278" stroke="#B88917" stroke-width="1.60833"
            stroke-linejoin="round" />

          <circle cx="27.8667" cy="23.7244" r="4.28889" stroke="#B88917" stroke-width="1.60833"
            stroke-linejoin="round" />

        </svg>

      </div>

      <!-- Content -->
      <div class="content">

        <div class="name-and-time">
          <h6>{{ item.notification_title }}</h6>
          <span>{{ getTimeAgo(item.created_at) }}</span>
        </div>

        <p class="msg">
          {{ item.message }}
        </p>

      </div>

      <div class="notification-actions">

        <button *ngIf="item.deep_link === 'winner_page'" class="btn btn-read" (click)="goToContestDetail(item)">
          View Detail
        </button>

        <button *ngIf="!item._notification_logs_of_notifications?.is_read" class="btn btn-read"
          (click)="markAsRead(item)">
          {{ 'notifications.read-status' | translate }}
        </button>

        <button *ngIf="item._notification_logs_of_notifications?.is_read" class="btn btn-unread"
          (click)="markAsUnread(item)">
          {{ 'notifications.unread' | translate }}
        </button>

      </div>

    </div>

    <!-- Empty State -->
    <div *ngIf="pagedNotifications.length === 0" class="empty-state" style="text-align: center; padding: 40px 20px;">

      <p style="color: #888; font-size: 16px;">
        {{ 'notifications.no-updates' | translate }}
      </p>

    </div>

  </div>

  <!-- Pagination -->
  <div *ngIf="pagedNotifications.length > 0 && totalPages > 1" class="pagination-container">

    <button (click)="prevPage()" [disabled]="currentPage === 1" class="prev-btn">
      Previous
    </button>

    <ng-container *ngFor="let page of getPageNumbers()">

      <button *ngIf="page !== '...'" (click)="goToPage(page)" [class.active-btn]="currentPage === page"
        class="number-btn">
        {{ page }}
      </button>

      <span *ngIf="page === '...'">...</span>

    </ng-container>

    <button (click)="nextPage()" [disabled]="currentPage === totalPages" class="next-btn">
      Next
    </button>

  </div>

</div>